import React from 'react';
import { useAppSelector } from '../../../../app/hooks';
import { mainColourSelector } from '../../../chatbotSlice';

interface ErrorMessageProps {
  title?: string;
  message?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  title = 'Unable to load details',
  message = 'We couldn\'t retrieve the vehicle information.'
}) => {
  const mainColour = useAppSelector(mainColourSelector);
  
  return (
    <div className="flex flex-col justify-center items-center h-64 px-6">
      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-red-100 mb-4">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" 
            stroke="#EF4444" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h3 className="text-lg font-bold text-center" style={{ color: mainColour }}>{title}</h3>
      <p className="text-center text-gray-600 mt-2">{message}</p>
    </div>
  );
};
